<template>
  <section id="chartComponent" class="assets_section noTopInnerPage container">
    <div class="row">
      <div class="col-12 col-lg-12 chart-container-box">
        <div class="inner inner-new chart-inner">
          <!-- desktop -->
          <div class="chart-nav d-lg-block d-md-block d-xl-block">
            <div class="btn-group" role="group" aria-label="Button group with nested dropdown">
              <div class="period-options">
                <span
                  v-for="period in dDown.period.options"
                  :class="{ active: dDown.period.period === period.p }"
                  :key="period.p"
                  @click="setPeriod(period.p)"
                  >{{ visualPeriodRepresentation(period) }}</span
                >
              </div>
              <div class="icon-filters">
                <div class="filter-wrapper cross" @click="showCross" :class="{active: dDown.cross.isActive }">
                  <svg xmlns="http://www.w3.org/2000/svg" width="22.804" height="22.804" viewBox="0 0 22.804 22.804"><defs></defs><g class="a" transform="translate(2.5 2.304)"><circle class="b" cx="9" cy="9" r="9"/><circle class="c" cx="9" cy="9" r="8"/></g><line class="a" y2="22.804" transform="translate(11.402)"/><line class="a" x1="22.804" transform="translate(0 11.402)"/><g class="a" transform="translate(6.5 6.304)"><circle class="b" cx="5" cy="5" r="5"/><circle class="c" cx="5" cy="5" r="4"/></g></svg>
                </div>
<!--                using "show" class instead of "active", because it is part of bootstrap's modal system -->
                <div class="filter-wrapper theme" @click="toggleDropDown('theme')" :class="{show: dDown.theme.isActive }">
                  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24" height="24" viewBox="0 0 24 24"><defs><clipPath id="a"><path class="a" d="M0,0H24V24H0Z"/></clipPath></defs><g class="b"><g transform="translate(-1085.001 -452)"><g transform="translate(1086 456)"><rect class="a" width="5" height="15.031" rx="1" transform="translate(0 1.734)"/><line class="c" y2="18.5" transform="translate(2.5)"/></g><g transform="translate(1094.5 460.5)"><rect class="a" width="5" height="8" rx="1" transform="translate(0 3.5)"/><line class="c" y2="14" transform="translate(2.5)"/></g><g transform="translate(1103.001 453.5)"><rect class="a" width="5" height="9" rx="1" transform="translate(0 1.5)"/><line class="c" y2="19" transform="translate(2.5)"/></g></g></g></svg>
                  <div class="menu-options-wrapper d-none d-md-block">
                    <ul class="dropdown-menu" aria-labelledby="btnGroupDrop1" id="optionsChartDisplayList">
                      <li v-for="theme in dDown.theme.options" :key="theme.txt" class="dropdown-item" @click="showTools(theme.name)">
                                          <span class="button scx-icon">
                                              <span class="image" :class="theme.name"></span>
                                          </span>
                        <span>{{theme.txt}}</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

          </div>
          <div id="chartOuterContainer">
            <div id="chartContainer" class="chart-box web" :class="{mobile: isMobileDevice()}"></div>
          </div>
          <!-- mobile -->
          <div class="chart-nav chart-nav-mobile d-block d-md-none">
            <!-- Modal 2 -->
            <div class="modal fade" id="Modal2" @click="toggleDropDown('theme')" :class="{show: dDown.theme.isActive }" tabindex="-1" role="dialog" aria-labelledby="ModalLabel2" aria-hidden="true">
              <div class="modal-dialog" role="document">
                <div class="modal-content">
                  <ul>
                    <li v-for="theme in dDown.theme.options" data-dismiss="modal" :key="theme.txt" class="dropdown-item" @click="showTools(theme.name)">
                                        <span class="button scx-icon">
                                            <span class="image" :class="theme.name"></span>
                                        </span>
                      <span>{{theme.txt}}</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { isMobileDevice } from "@/utils/general";
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
import Vue from "vue";


export default {
  name: "Chart",
  props: ["symbol"],
  data() {
    return {
      dDown: {
        period: {
          isActive: false,
          period: 60,
          options: [
            { p: 1, amount: "1", unit: "minute" },
            { p: 5, amount: "5", unit: "minutes" },
            { p: 15, amount: "15", unit: "minutes" },
            { p: 60, amount: "1", unit: "hour" },
            { p: 240, amount: "4", unit: "hours" },
            { p: 1440, amount: "1", unit: "day" },
            { p: 10080, amount: "1", unit: "week" },
            { p: 43200, amount: "1", unit: "month" }
          ]
        },
        theme:{
          isActive: false,
          name: 'hollowCandle',
          options:[{name:"bar", txt:"Bar"},
            {name:"coloredBar", txt:"Colored Bar"},
            {name:"candle", txt:"Candle"},
            {name:"hollowCandle", txt:"Hollow Candle"},
            {name:"heikinAshi", txt:"Heikin Ashi"},
            {name:"renko", txt:"Renko"},
            {name:"lineBreak", txt:"Line Break"},
            {name:"kagi", txt:"Kagi"},
            {name:"kagi", txt:"Line"},
            {name:"mountain", txt:"Mountain"},
            {name:"pointAndFigure", txt:"Point And Figure"}]
        },
        cross:{
          isActive: false,
        },
      }
    }
  },
  created(){
    this.incrementPendingApiCallsCount(); //aimed to be decreamented at ws.onemessage
    this.setChartSymbol(this.symbol);
    this.exposeGraphSocketInit();
    this.loadChartCss();
    this.loadChartScripts();
    this.getInfoFromWebsite("traderDictionary");
  },
  computed: {
    ...mapState(["webInfo","symbolsData","regulation"]),
    ...mapGetters(["alvexoWebsite","traderDict","t"]),
    alvexoWebsiteProd() {
      //due to chart's package license problem at stage on eu domain
      return this.alvexoWebsite.replace("stage", "www");
    }
  },
  methods: {
    ...mapMutations([
      "incrementPendingApiCallsCount",
      "decrementPendingApiCallsCount"
    ]),
    ...mapMutations("symbolsSocket", ["setChartSymbol"]),
    ...mapActions(["getInfoFromWebsite"]),
    toggleDropDown: function(dDownKey) {
      this.dDown[dDownKey].isActive = !this.dDown[dDownKey].isActive;
    },
    graphSocketInit: function(period){
      this.incrementPendingApiCallsCount(); //aimed to be decreamented at ws.onemessage
      this.graphSocketInitInternal(period);
    },
    graphSocketInitInternal: function(period) {
      //important note: this function decrements the loader counter but its not incrementing it. incrementing is being done via the "graphSocketInit" func or via the creation of the current component. (if incrementing the loader inside the graphSocketInit function the loader might end before the function run and "blink"
      this.getInfoFromWebsite("symbols").then(()=>{
        const that = this;
        //open socket for graph data
        var ws = new WebSocket("wss://trader.alvexo.com/wsapp");
        var obj = {
          symbol: this.symbol,
          type: "chart",
          period: period
        };

        // eslint-disable-next-line no-unused-vars
        ws.onopen = function(event) {
          ws.send(JSON.stringify(obj));
        };

        //on message create graph
        ws.onmessage = function(evt) {
          var data = JSON.parse(evt.data);
          if (
              typeof createChart === "function" &&
              data.chartData != undefined &&
              data.chartData.symbol == that.symbol
          ) {
            //create first graph
            // eslint-disable-next-line no-undef
            createChart(data.chartData, that.symbolsData[that.symbol].digits);
            that.decrementPendingApiCallsCount();
          }
        }
      })
    },
    isMobileDevice: isMobileDevice,
    showTools:function(theme){
      this.dDown.theme.name = theme;
      window.gChart.priceStyleKind = theme;
    },
    setPeriod: function(period) {
      this.changeCrossStatusCross(false);
      this.dDown.period.period = period;
      delete window.gChart;
      document.getElementById("chart").remove();
      this.graphSocketInit(period);
      // var rates = new LiveRates(true, true, false, current, period);
      // rates.setVisibleSymbols([current]);
      // rates.getSymbolData(rates.visibleSymbols);
    },
    showCross: function(){
      if(this.dDown.cross.isActive){
        this.changeCrossStatusCross(false);
      } else{
        this.changeCrossStatusCross(true);
      }
    },
    changeCrossStatusCross: function(newStatus){
      const scxPanel = document.querySelector(".scxPanelTitle");
      const gCrossHair = window.gChart.crossHair;
      const stockChart = window.StockChartX;
      if(newStatus){
        gCrossHair.crossHairType = stockChart.CrossHairType.CROSS;
        gCrossHair.show;
        scxPanel.style.display="block";
        this.dDown.cross.isActive = true;
      } else{
        gCrossHair.crossHairType= stockChart.CrossHairType.NONE;
        gCrossHair.hide;
        scxPanel.style.display="none";
        this.dDown.cross.isActive = false;
      }
    },
    loadChartCss: function(){
      const baseUrl = `${this.alvexoWebsiteProd}charts/scripts/chart_n/css/`;
      const cssFileNames = ["StockChartX","StockChartX.External","StockChartX.UI"];
      const head = document.getElementsByTagName('head')[0];
      cssFileNames.forEach(cssFileName =>{
        let link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href=baseUrl+cssFileName+".min.css"
        head.appendChild(link);
      })
    },
    loadChartScripts: function(){ //import relevant files from Chart library used at the website (package is not available at npm)
      const baseChartsUrl = `${this.alvexoWebsiteProd}charts/`;
      const urlChart_nAddition="scripts/chart_n/";
      const minScriptArr = ["Intl","es6-promise","detectizr","html2canvas","moment","i18next","i18nextXHRBackend","jquery-i18next"]

      const scriptPromises = [];
      minScriptArr.forEach(scriptName =>{
        let scriptUrl = baseChartsUrl+urlChart_nAddition+'scripts/'+scriptName+'.min.js';
        scriptPromises.push(Vue.loadScript(scriptUrl));
      })
      scriptPromises.push(Vue.loadScript(baseChartsUrl+'scripts/constants_en.js'));
      Promise.all(scriptPromises)
        .then(() =>
          Vue.loadScript(
            baseChartsUrl +
              urlChart_nAddition +
              "scripts/" +
              "StockChartX" +
              ".min.js"
          )
        )
        .then(() =>
          Vue.loadScript(
            baseChartsUrl +
              urlChart_nAddition +
              "scripts/" +
              "StockChartX.UI" +
              ".min.js"
          )
        )
        .then(() =>
          Vue.loadScript(
            baseChartsUrl +
              urlChart_nAddition +
              "scripts/" +
              "StockChartX.External" +
              ".min.js"
          )
        )
          //todo: make the "ver" number more generic and auto generated
          .then(() =>
          Vue.loadScript(process.env.BASE_URL + "js/chart-constructor.js"+"?ver=0.1")
        );
    },
    exposeGraphSocketInit: function(){
      const that=this;
      window['globalGraphSocketInit'] = function(){
        that.graphSocketInitInternal(that.dDown.period.period);
      };
    },
    visualPeriodRepresentation(period) {
      return `${period.amount} ${this.traderDict(period.unit)}`;
    }
  }
}
</script>


<style lang="scss">
.alvexo_plus_wrapper{ //avoid influence the website's popups
  #optionsChartDisplayList::-webkit-scrollbar-track {
    background: #ffffff;
  }
  @media screen and (max-width: 991px){
    .modal-backdrop {
      position: inherit;
    }
  }
  /*happens at the prod by bootstrap*/
  .scxComponentsContainer{
    display: none;
  }
}

</style>
<style lang="scss" scoped>
//START OF CODE DUPLICATED FROM WEBSITE'S PREVIOUS PAGE with addition of v-deep for the injected table
::v-deep{
  .scxValueScale.scxRightValueScale {
    display: none;
  }
  .scxContainer {
    max-width: 100%;
    right: 0;
  }
  .scxPanelTitle {
    display: none;
  }

  .scxToolbar {
    display: none !important;
  }
  .scxNavigation{
    display: none;
  }
}


.chart-nav {
  //position: absolute;
  //left: 35px;
  //top: 45px;
  position: relative;
  margin-bottom: 20px;
  z-index: 18;
  direction: ltr;
  @media screen and (max-width: 768px) {
    margin-bottom: 16px;
  }
}

.assets_section .inner-new {
  border: 1px solid #BCBCBC;
}


//.assets_section .container .row:first-of-type {
//  height: 100%;
//  justify-content: space-between;
//  align-items: center;
//}
.assets_section .row .chart-container-box{
  padding: 0;
}

.assets_section .row .chart-container-box .chart-inner {
  padding: 20px;
  background: #ffffff;
}


.scx-icon {
  width: 40px;
  height: 43px;
}

.mobile-tools .scx-icon {
  top: 12px !important;
}


/* top buttons*/
#btnGroupDrop1 span.image#image-theme {
  color: #555;
}

#btnGroupDrop1 .scx-icon {
  width: 21px;
  height: auto;
  top: 0;
}

.assets_section .btn,
.show > .btn-light.dropdown-toggle,
.show > .btn-light.dropdown-toggle:focus {
  /*padding: .375rem .75rem !important;*/
  font-size: 1rem !important;
  display: flex;
  padding: 0;
  width: 165px;
  justify-content: center;
  align-items: center;
  border: 1px solid #cfcfcf;
  background-color: #fff;
  box-shadow: none;
}

.btn-group {
  //margin-bottom: 10px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  @media screen and (max-width: 768px) {
    padding-right: 19px;
    padding-left: 19px;
  }

  .period-options{
    color: #9E9E9E;
    size: 0.75rem;
    span{
      //margin-right: 1.375rem;
      &:hover{
        cursor: pointer;
      }
      padding: 0 0.5rem;

      font-size: 0.75rem;
      display: inline-block;
      text-align: center;
      @media screen and (max-width: 460px){
        min-width: 30px;
      }
      &.active{
        color: #FFFFFF;
        border-radius: 30px;
        background-color: #1C79BE;
      }
    }
  }

  .icon-filters{
    display: flex;
    flex-direction: row;
    .filter-wrapper{
      &:not(:first-of-type){
        margin-left: 1.5rem;
        @media screen and (max-width: 460px){
          margin-left: 1rem;
        }
      }
      &:hover{
        cursor: pointer;
      }
      &.show{
        > .menu-options-wrapper .dropdown-menu{
          display: block;
        }
      }

      &.theme{
        svg{
          .a{fill:#9e9e9e;}.b{clip-path:url(#a);}.c{fill:none;stroke:#9e9e9e;stroke-width:2px;}
        }
        &:hover, &.show{
          svg{
            .a,.b{fill:#1c79be;}
            .c{stroke:#1c79be;}
          }
        }
        .dropdown-menu{
          left: unset;
          right: 0;
        }
      }
      &.cross{
        svg{
          .a,.c{fill:none;}
          .a{stroke:#9e9e9e;stroke-width:2px;}
          .b{stroke:none;}
        }
        &.active{
          svg{
            .a{stroke:#1c79be;}
          }
        }
        &:hover{
          @media screen and (min-width: 768px){ //in order to fix "bug" at mobile which activates the "hover" and doesn't stops after click
            svg{
              .a{stroke:#1c79be;}
            }
          }
        }
      }

    }
  }
}



.icon-period-big {
  font-size: 14px;
  color: #555;
  display: inline-block;
  vertical-align: middle;
  font-weight: 700;
}

.icon-period-small {
  font-size: 11px;
  margin-top: -5px;
  line-height: 0;
  color: #555;
}

.mobile-tools .icon-period-small {

}



.mobile-tools .icon-period-big {

}



/* bar */
.chart-nav .scx-icon .bar.image:before {
  content: "\6a" !important;
}

/* coloredBar */
.chart-nav .scx-icon .coloredBar.image {
  /*position: relative;*/
  /*width: 100%;*/
  /*height: 100%;*/
}

.chart-nav .scx-icon .coloredBar.image:before {
  content: "\6e" !important;
  /*position: absolute;*/
  /*top: 9px;*/
  /*left: 9px;*/
  /*width: 22px !important;*/
  /*height: 22px;*/
  color: #FFC107;
  position: absolute;
}

.chart-nav .scx-icon .coloredBar.image:after {
  content: "\6f" !important;
  /*position: absolute;*/
  /*top: 10px;*/
  /*right: 9px;*/
  /*width: 22px !important;*/
  /*height: 22px;*/
  /*font-size: 22px;*/
  color: #F75B54;
}

.chart-nav .scx-icon .coloredBar.image {
  /*height: 40px;*/
  /*width: 40px;*/
}

.chart-nav .scx-icon .coloredBar.image:before {
  /*top: 9px;*/
  /*left: 21px;*/
}

.chart-nav .scx-icon .coloredBar.image:after {
  /*top: 14px;*/
  /*right: 22px;*/
}

/* candle */
.chart-nav .scx-icon .candle.image:before {
  content: "\6b" !important;
}

/* hollowCandle */
.chart-nav .scx-icon .hollowCandle.image:before {
  content: "\49" !important;
}

/* heikinAshi */
.chart-nav .scx-icon .heikinAshi.image:before {
  content: "\48" !important;
}

/* renko */
.chart-nav .scx-icon .renko.image:before {
  content: "\35" !important;
}

/* lineBreak */
.chart-nav .scx-icon .lineBreak.image:before {
  content: "\51" !important;
}

/* kagi */
.chart-nav .scx-icon .kagi.image:before {
  content: "\4e" !important;
}

/* line */
.chart-nav .scx-icon .line.image:before {
  content: "\4f" !important;
}

/* mountain */
.chart-nav .scx-icon .mountain.image:before {
  content: "\53" !important;
}

/* pointAndFigure */
.chart-nav .scx-icon .pointAndFigure.image:before {
  content: "\57" !important;
}



.mobile-tools .container .tools-row {
  background-color: #F4F4F4;
  position: relative;
  top: -5px;
}

.mobile-tools .container .row .col {
  text-align: center;
}


#optionsChartDisplayList {max-height: 275px; overflow-y: scroll;}
#optionsChartDisplayList .dropdown-item{display: flex;justify-content: flex-start;align-items: center;}
#optionsChartDisplayList .dropdown-item .button.scx-icon{display: flex;justify-content: center;align-items: center;width: auto;height: auto;margin:10px 10px 10px 0;}
#optionsChartDisplayList .dropdown-item .button.scx-icon .image.coloredBar:before{position: absolute;}


.dropdown-item:hover {
  cursor: pointer;
}

.modal{
  z-index: 1050;
}

.chart-nav-mobile {
  position: relative;
  left: 0;
  top: 0;
}

@media screen and (max-width: 991px) {
  #chartComponent {
    padding: 0;
  }


  .mobile-tools .container .tools-row {
    top: 0;
    background-color: inherit;
    border-top: 1px solid #C4C1C1;
    align-items: center;
  }

  .mobile-tools .container .tools-row button {
    border: none;
    background: transparent;
    height: 100%;
    &:focus{
      outline: none;
    }
  }

  .mobile-tools .container .row .col:last-of-type {
    border-left: 1px solid #C4C1C1;
  }

  .assets_section .container .row:last-of-type .col-12:first-of-type {
    order: 1;
  }

  .assets_section .container .row:last-of-type .col-12:nth-child(3){
    order: 2;
  }

  .assets_section .container .row:last-of-type .col-12:last-of-type{
    order: 3;
  }

  .assets_section .container .row:last-of-type .col-12:nth-child(2){
    order: 4;
  }
}

#Modal1,#Modal2{
  &.show{
    display: block;
  }
}

@media screen and (max-width: 576px) {
  .chart-nav #Modal2,.chart-nav #Modal1{overflow: scroll;}
  .chart-nav #Modal1 .modal-dialog,.chart-nav #Modal2 .modal-dialog{margin-top: 60px;}
  .chart-nav #Modal1 .modal-dialog .modal-content,.chart-nav #Modal2 .modal-dialog .modal-content{border: none;border-bottom: 1px solid rgba(0,0,0,.2);border-radius: 0;}
  .chart-nav #Modal2 .modal-dialog .modal-content .dropdown-item{display: flex;justify-content: flex-start;align-items: center;}
  .chart-nav #Modal2 .modal-dialog .modal-content .dropdown-item .button.scx-icon{display: flex;justify-content: center;align-items: center;width: auto;height: auto;margin:10px 10px 10px 0;}
  .chart-nav #Modal2 .modal-dialog .modal-content .dropdown-item .button.scx-icon .image.coloredBar:before{position: absolute;}


  .assets_section .row .chart-container-box .chart-inner {
    padding: 20px 0 0;
  }
  header {
    height: 60px;
    box-shadow: 0 0 10px -3px rgba(0, 0, 0, 0.2);
  }
}

//END OF CODE DUPLICATED FROM WEBSITE'S PREVIOUS PAGE


#chartContainer{
  width:100%;height:400px;
}
#chartContainer.mobile{
   //width:96%; //used at prod with no clear reason
  height:223px;
  //margin: 1%; //used at prod with no clear reason
 }

.assets_section .row{ //some manual fix to the bootstap because from some reason the content overflows out of the page
  margin-right: inherit;
  margin-left: inherit;
  max-width: 100%;
}

.ar{
  .chart-container-box{
    direction: ltr; //table does not appearing without it
  }
}


</style>